import { BrowserModule } from '@angular/platform-browser';
import { NgModule,APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UiHeaderComponent } from './_layout/ui-header/ui-header.component';
import { UiFooterComponent } from './_layout/ui-footer/ui-footer.component';
import { UILayoutComponent } from './_layout/ui-layout/ui-layout.component';
import { DashboardComponent } from '../../src/app/modules/user/dashboard/dashboard.component';
import { HttpClientModule ,HTTP_INTERCEPTORS } from '@angular/common/http';
import {CommonService} from './services/common.service';
import { AdminDashboardComponent } from './modules/admin/admin-dashboard/admin-dashboard.component';
import { SystemSettingsComponent } from './modules/admin/system-settings/system-settings.component';
import { SigninComponent } from './modules/admin/signin/signin.component';
import { ResultsComponent } from './modules/user/results/results.component';
import { AdminHeaderComponent } from './_layout/admin-header/admin-header.component';
import { AdminLayoutComponent } from './_layout/admin-layout/admin-layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MatButtonModule,MatAutocompleteModule} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {NgxSpinnerModule } from 'ngx-spinner';
// import { PaginationComponent } from './modules/app-pagination/app-pagination/app-pagination.component';
import { PaginationModule } from './modules/app-pagination/app-pagination.module';
import { AccessibilityComponent } from './modules/user/accessibility/accessibility.component';
import { PrivacypolicyComponent } from './modules/user/privacypolicy/privacypolicy.component';
import { TermsOfUseComponent } from './modules/user/terms-of-use/terms-of-use.component';
import { PersistenceModule } from 'angular-persistence';
import { ContactusComponent } from './modules/user/contactus/contactus.component';
import { FaqComponent } from './modules/user/faq/faq.component';
import { AgmCoreModule } from '@agm/core';
// import { GooglemapsComponent } from './modules/user/googlemaps/googlemaps.component';
import { SendrequestComponent } from './modules/user/sendrequest/sendrequest.component';
import { ProvidersearchComponent } from './modules/user/providersearch/providersearch.component';
//import { AgmDirectionModule } from 'agm-direction'; 
import { ErrorIntercept } from './http-error.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    UiHeaderComponent,
    UiFooterComponent,
    UILayoutComponent,
    DashboardComponent,
    AdminDashboardComponent,
    SystemSettingsComponent,
    SigninComponent,
    ResultsComponent,
    AdminHeaderComponent,
    AdminLayoutComponent,
    AccessibilityComponent,
    PrivacypolicyComponent,
    TermsOfUseComponent,
    ContactusComponent,
    FaqComponent,
    // GooglemapsComponent,
    SendrequestComponent,
    ProvidersearchComponent,
    // PaginationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    PaginationModule,
    PersistenceModule,
     AgmCoreModule.forRoot({
       apiKey: 'AIzaSyA0b45RFS5_WMTVLTuCzTr3ndulH5x1Wd0'      
     }),

  ],
  providers: [CommonService,
    {
      provide: APP_INITIALIZER, useFactory: (commonService: CommonService) => () =>
        commonService.getConfig().then(obj => {
          if (obj) {
            let data = <any>(obj);
             
            localStorage.clear();
            //set item with values
            localStorage.setItem("APIHostAddress", data.APIHostAddress);
            localStorage.setItem("AssetRepositoryUrl", data.AssetRepositoryUrl);
            localStorage.setItem("ContentPath", data.ContentPath);  
            localStorage.setItem("pageCount", data.pageCount); 
            localStorage.setItem("TotalPages", data.TotalPages); 
            localStorage.setItem("Radius", data.Radius); 
            localStorage.setItem("WebsiteUrl", data.WebsiteUrl);
            localStorage.setItem("PortalAssertUrl", data.PortalAssertUrl);
            localStorage.setItem("NonDiscriminationNotice", data.NonDiscriminationNotice);     
            localStorage.setItem("Plans", data.Plans);
            localStorage.setItem("PrintRequestPlans", data.PrintRequestPlans); 
            localStorage.setItem("PrintDirectoryTypes", data.PrintDirectoryTypes);     
          }
        }),
      deps: [CommonService], multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorIntercept,
      multi: true
    }],
    
  bootstrap: [AppComponent]
})
export class AppModule { }
